export default function setMarquee() {

  /* Elements */
  const marqueeElm = document.querySelector('.js-marquee');
  const marqueeTxtElm = document.querySelector('.js-marqueeTxt');
  const mvSec = document.getElementById('js-mvSec');

  /* SPのNEWSエリアの位置調整 */
  const newsElm = document.getElementById('js-marqueeCont');
  const headerElm = document.getElementById('header');
  let h = innerHeight;
  let posT = h - headerElm.clientHeight - newsElm.clientHeight;
  newsElm.setAttribute('style', `top: ${posT}px; bottom: auto;`);
  window.addEventListener('resize', (e) => {
    h = innerHeight;
    posT = h - headerElm.clientHeight - newsElm.clientHeight;
    newsElm.setAttribute('style', `top: ${posT}px; bottom: auto;`);
  });
  const mediaQuerylList = matchMedia('(max-width: 768px)');
  let i = 0; // move
  let marqueeElmW = marqueeElm.clientWidth;
  let marqueeTxtElmW = 0 - marqueeTxtElm.clientWidth;
  let ticking, timer

  /* Move function */
  const setMove = () => {
    let interval = 10; // Sec
    timer = setInterval(() => {
      i--;
      marqueeTxtElm.setAttribute('style', `transform: translateX(${i}px);`);
      if (i < marqueeTxtElmW) {
        i = +marqueeElmW;
      }
    }, interval);
  }

  /* Resize function */
  addEventListener('resize', windowResize, !document.documentMode ? {
    passive: true
  } : false);

  function windowResize() {
    if (!ticking) {
      requestAnimationFrame(() => {
        ticking = false;
        marqueeElmW = marqueeElm.clientWidth;
        marqueeTxtElmW = 0 - marqueeTxtElm.clientWidth;
      });
      ticking = true;
    }
  }

  /* observer */
  // function viewArea(entries, object) {
  //   entries.forEach(function (entry, i) {
  //     if (entry.isIntersecting) {
  //       mediaQuerylList.addListener(onMediaQueryChanage);
  //     } else {
  //       clearInterval(timer);
  //     }
  //   });
  // };
  // let observer = new IntersectionObserver(viewArea);

  /* MediaQuery */
  function onMediaQueryChanage(mediaQuerylList) {
    if (mediaQuerylList.matches === true) {
      setMove();
    } else {
      clearInterval(timer);
      marqueeTxtElm.setAttribute('style', '');
    }
  }

  /* init */
  mediaQuerylList.addListener(onMediaQueryChanage);
  onMediaQueryChanage(mediaQuerylList); // 一度発火しておく
  // observer.observe(mvSec); // observer発火

}